module.exports = __webpack_public_path__ + "img/1535347085.c761bfe6.jpg";